var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDrillBuilderIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_297",
    "data-name": "Group 297",
    transform: "translate(-155.996 -637)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    d: "M41.607,31.656h2.3V25.148A1.148,1.148,0,0,0,42.756,24H36.248v2.3h3.736l-9.724,9.724a4.211,4.211,0,1,0,1.623,1.623l9.724-9.724Zm-13.4,9.953A1.914,1.914,0,1,1,30.123,39.7,1.914,1.914,0,0,1,28.209,41.61Z",
    transform: "translate(132 613.092)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    "data-name": "Path 520",
    d: "M27.383,31.6l2.3-2.3,2.3,2.3L33.6,29.977l-2.3-2.3,2.3-2.3L31.977,23.76l-2.3,2.3-2.3-2.3L25.76,25.383l2.3,2.3-2.3,2.3Z",
    transform: "translate(130.911 613.24)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    d: "M61.977,53.76l-2.3,2.3-2.3-2.3L55.76,55.383l2.3,2.3-2.3,2.3L57.383,61.6l2.3-2.3,2.3,2.3L63.6,59.977l-2.3-2.3,2.3-2.3Z",
    transform: "translate(112.396 594.725)",
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrillBuilderIcon);
export default __webpack_public_path__ + "static/media/drill-builder-icon.d7c6e929646251f63f11dc1f01950006.svg";
export { ForwardRef as ReactComponent };